import React, { useRef } from 'react';
import { useLocation, useParams, Link } from 'react-router-dom';
import { AppBar, Toolbar, Typography, Button, Box, Paper } from '@mui/material';
import { Save, Cancel } from '@mui/icons-material';
import AddEditSubCategory from './../../AddEditSubCategory/AddEditSubCategory';
import MainContentContainer from '../../MainContentContainer/MainContentContainer';

const SubCategoryAddEditPage = () => {
  const location = useLocation();
  const params = useParams();
  const isEdit = location.pathname.indexOf('edit') > -1;
  const subCategoryRef = useRef();

  const handleSave = () => {
    subCategoryRef.current.submit();
  };

  return (
    <MainContentContainer sx={{ paddingBottom: 4 }}>
      <AppBar position="static">
        <Toolbar>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            {isEdit ? 'Edit Sub-Category' : 'Create New Sub-Category'}
          </Typography>
          <Button
            color="error"
            component={Link}
            to="/subcategories"
            startIcon={<Cancel />}
            variant="contained"
            sx={{ marginRight: 2 }}
          >
            Cancel
          </Button>
          <Button
            color="success"
            onClick={handleSave}
            startIcon={<Save />}
            variant="contained"
          >
            {isEdit ? 'Update' : 'Create'}
          </Button>
        </Toolbar>
      </AppBar>
      <Box gap={4}>
        <Paper sx={{ padding: 2 }}>
          <AddEditSubCategory ref={subCategoryRef} isEdit={isEdit} selectedId={params.id} />
        </Paper>
      </Box>
    </MainContentContainer>
  );
};

export default SubCategoryAddEditPage;
